// ABOUTME: This component displays a single-dataset Manhattan plot viewer in an iframe.
// ABOUTME: It loads a Panel app for viewing SNP-level associations for a specific phenotype.

import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { UserAuthService } from '../../services/user-auth.service';
import { StudyFamily } from '../../interfaces/i-datasets';
import { navFor } from '../../study-families';

@Component({
  selector: 'app-display-gene',
  templateUrl: './display-gene.component.html',
  styleUrl: './display-gene.component.scss',
})
export class DisplayGeneComponent implements OnInit {
  @Input('id') datasetName?: string;
  /** Bound from the route's `data.family` via bindToComponentInputs. */
  @Input() family: StudyFamily = 'gwas16';
  plotEndpoint: string = environment.baseUrl + 'manhattan/plot';
  plotSrc: SafeResourceUrl | undefined;
  @ViewChild('iframe') iframe: ElementRef | undefined;

  constructor(
    public auth: UserAuthService,
    public sanitize: DomSanitizer,
    private router: Router,
  ) {}

  ngOnInit() {
    this.loadPlot();
  }

  loadPlot() {
    this.plotSrc = this.sanitize.bypassSecurityTrustResourceUrl(
      this.plotEndpoint + '?token=' + this.auth.getToken() + '&dataset=' + this.datasetName
    );
  }

  goBack(): void {
    this.router.navigate([`${navFor(this.family).baseRoute}/datasets`]);
  }
}
